import React from 'react'
import { NavLink } from 'react-router-dom'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import changes from '../../changelog'

class Sidebar extends React.PureComponent {
	render() {
		const { hash } = this.props
		const changeLogDates = changes
			.sort((a, b) => new Date(b.release) - new Date(a.release))
			.map(log => (
				<div key={log.release} className="nav-link">
					<NavLink
						to={'/changelog#' + log.release}
						className={hash === '#' + log.release ? 'active' : ''}
					>
						{log.release}
					</NavLink>
				</div>
			))

		return (
			<nav className="sidebar">
				<h2>Changelog</h2>
				<div className="scroll">
					<div className="nav-links">{changeLogDates}</div>
				</div>
			</nav>
		)
	}
}

Sidebar.propTypes = {
	hash: PropTypes.string,
}

const mapStateToProps = (state, ownProps) => {
	return {
		hash: location.hash,
	}
}

export default connect(mapStateToProps)(Sidebar)



// WEBPACK FOOTER //
// ./src/components/changelog/Sidebar.js